(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  function updateHeroHeight() {
    const hero = document.querySelector('.hero');
    if (!hero) return;

    const media = hero.querySelector('.hero__media');
    if (!media) return;

    if (window.innerWidth < 750) {
      hero.style.minHeight = media.offsetHeight + 'px';
    } else {
      hero.style.minHeight = '';
    }
  }

  window.addEventListener('load', updateHeroHeight);
  window.addEventListener('resize', updateHeroHeight);

  document.querySelectorAll('.hero img').forEach(function(img) {
    img.addEventListener('load', updateHeroHeight);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
